(() => {
  const BACKEND_URL = "https://frailejoneditores.pythonanywhere.com/chat";

  // ID persistente de conversación (memoria por pestaña/navegador)
  const CONV_ID = (() => {
    const k = "fj-conv-id";
    let v = localStorage.getItem(k);
    if (!v) { v = (crypto.randomUUID?.() || String(Date.now())); localStorage.setItem(k, v); }
    return v;
  })();

  // --- Estilos rápidos ---
  const css = `
  #fj-launcher{position:fixed;right:18px;bottom:18px;z-index:99999;border:0;border-radius:999px;padding:12px 16px;box-shadow:0 6px 20px rgba(0,0,0,.15);cursor:pointer;background:#0f172a;color:#fff}
  #fj-widget{position:fixed;right:18px;bottom:80px;width:340px;max-width:92vw;height:460px;background:#fff;border-radius:16px;box-shadow:0 12px 36px rgba(0,0,0,.18);display:none;flex-direction:column;overflow:hidden;z-index:99998}
  #fj-header{background:#0f172a;color:#fff;padding:12px 14px;font-weight:600;display:flex;align-items:center;justify-content:space-between}
  #fj-body{padding:10px;gap:8px;display:flex;flex-direction:column;height:100%;overflow:auto;background:#f8fafc}
  .fj-msg{max-width:85%;font-size:14px;line-height:1.4;padding:10px 12px;border-radius:12px}
  .fj-user{align-self:flex-end;background:#e2e8f0}
  .fj-bot{align-self:flex-start;background:#fff}
  #fj-inputbar{display:flex;gap:8px;padding:10px;border-top:1px solid #e5e7eb;background:#fff}
  #fj-input{flex:1;font-size:14px;padding:10px 12px;border:1px solid #cbd5e1;border-radius:10px}
  #fj-send{padding:10px 14px;border:0;border-radius:10px;background:#0f172a;color:#fff;cursor:pointer}
  `;
  const style = document.createElement("style"); style.textContent = css; document.head.appendChild(style);

  // --- UI ---
  const root = document.getElementById("frailejon-chat-root") || document.body;
  const launcher = document.createElement("button");
  launcher.id = "fj-launcher"; launcher.textContent = "¿Te ayudo a elegir?";
  const widget = document.createElement("div"); widget.id = "fj-widget";
  widget.innerHTML = `
    <div id="fj-header">Librero Frailejón <button id="fj-close" style="all:unset;cursor:pointer">✕</button></div>
    <div id="fj-body">
      <div class="fj-msg fj-bot">¡Hola! ¿Buscas un regalo o algo para ti? Puedo recomendarte libros y dejarte el enlace de compra.</div>
    </div>
    <div id="fj-inputbar">
      <input id="fj-input" placeholder="Escribe aquí…"/>
      <button id="fj-send">Enviar</button>
    </div>
  `;
  root.appendChild(launcher); root.appendChild(widget);

  const body = widget.querySelector("#fj-body");
  const input = widget.querySelector("#fj-input");

  function scrollBottom(){ body.scrollTop = body.scrollHeight; }
  function addMsg(html, who="bot"){
    const d = document.createElement("div");
    d.className = `fj-msg ${who==="user"?"fj-user":"fj-bot"}`;
    if (who === "bot") d.innerHTML = html; else d.textContent = html;
    body.appendChild(d); scrollBottom();
  }

  async function send(){
    const text = input.value.trim(); if(!text) return;
    addMsg(text, "user"); input.value = ""; addMsg("…", "bot");
    try{
      const r = await fetch(BACKEND_URL, {
        method:"POST",
        headers: {"Content-Type":"application/json"},
        body: JSON.stringify({ message: text, conversation_id: CONV_ID })
      });
      const j = await r.json();
      body.lastChild.remove();
      addMsg(j.response || j.error || "Ups, no pude responder. Intenta de nuevo.");
    }catch(e){
      body.lastChild.remove();
      addMsg("No pude conectar con el servidor. Intenta más tarde.");
    }
  }

  launcher.onclick = () => { widget.style.display = "flex"; launcher.style.display = "none"; };
  widget.querySelector("#fj-close").onclick = () => { widget.style.display = "none"; launcher.style.display = "inline-block"; };
  widget.querySelector("#fj-send").onclick = send;
  input.addEventListener("keydown", (e)=>{ if(e.key==="Enter") send(); });
})();
